import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductForm from '../components/inventory/ProductForm';
import { posApi, productsApi } from '../services/api';

const fmt = (n) => Number(n || 0).toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function CreateProductPage() {
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);
    const [created, setCreated] = useState(null);
    const [importingReceipt, setImportingReceipt] = useState(false);
    const [receiptImport, setReceiptImport] = useState(null);
    const [prefillProduct, setPrefillProduct] = useState(null);

    const importPurchaseReceipt = async (file) => {
        if (!file) return;
        setImportingReceipt(true);
        const response = await posApi.importPurchaseReceipt(file);
        setImportingReceipt(false);

        if (!response.success) {
            window.alert(response.error || 'Failed to parse receipt');
            return;
        }

        setReceiptImport(response.data);
    };

    const applyReceiptLine = (item) => {
        const matched = item.product_match || {};
        setPrefillProduct({
            name: item.description || matched.name || '',
            sku: matched.sku || '',
            barcode: matched.barcode || '',
            category: matched.category || '',
            unit_cost: Number(item.unit_price || matched.unit_cost || 0),
            selling_price: Number(item.unit_price || matched.selling_price || 0),
            quantity_in_stock: Number(item.quantity || 0),
            reorder_level: 10,
            description: item.source_line || '',
            metadata: {
                brand: matched.metadata?.brand || '',
                unit: matched.metadata?.unit || 'Pc',
                sub_category: matched.metadata?.sub_category || '',
                warranty: matched.metadata?.warranty || '',
            },
        });
    };

    const handleSubmit = async (payload) => {
        setSaving(true);
        const response = await productsApi.create(payload);
        setSaving(false);

        if (!response.success) {
            window.alert(response.error || 'Unable to create product');
            return;
        }

        setCreated(response.data);
        navigate('/inventory');
    };

    return (
        <div className="products-page">
            <div className="page-header products-header">
                <div>
                    <h2>Create Product</h2>
                    <p>Dashboard <span className="crumb-sep">›</span> Create Product</p>
                </div>
            </div>

            <section className="products-shell create-product-shell">
                <div className="receipt-import-panel" style={{ marginBottom: 18 }}>
                    <label className="field-label">Import purchase receipt (PDF/Image)</label>
                    <input
                        type="file"
                        accept="application/pdf,image/*"
                        onChange={(e) => importPurchaseReceipt(e.target.files?.[0])}
                        disabled={importingReceipt}
                    />
                    <div className="muted-sm">Upload a supplier receipt to extract item name, quantity and unit price for faster product creation.</div>
                    {importingReceipt && <div className="muted-sm">Parsing receipt...</div>}
                    {receiptImport && (
                        <div className="receipt-import-result">
                            <div className="muted-sm" style={{ marginBottom: 8 }}>
                                Extracted {receiptImport.totals?.extracted_lines || 0} lines.
                            </div>
                            <div className="receipt-import-preview">
                                {(receiptImport.parsed_items || []).slice(0, 12).map((item, idx) => (
                                    <div key={`${item.source_line}-${idx}`} className="receipt-import-line">
                                        <span>{item.description}</span>
                                        <span>Qty {item.quantity} × ₦{fmt(item.unit_price)}</span>
                                        <button className="btn btn-sm" type="button" onClick={() => applyReceiptLine(item)}>Use in form</button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <ProductForm product={prefillProduct} saving={saving} onSubmit={handleSubmit} submitLabel="Create Product" />
                {created ? (
                    <div className="generated-code-panel">
                        <div>
                            <p className="barcode-preview-label">Saved Product Barcode</p>
                            <strong>{created.barcode}</strong>
                        </div>
                        {created.barcode_image ? (
                            <div className="generated-image-wrap">
                                <img src={`data:image/png;base64,${created.barcode_image}`} alt="Generated barcode" />
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </section>
        </div>
    );
}
